import http from 'plugins/axios';

export default {
  syncDoubleMiningConfig() {
    return http.get({
      url: '/admin/mining/miningDouble/initMiningCycleToRedis'
    });
  }
};
